// La promoción de 6 boletos por $800 termina el 31 de octubre de 2026 (hora de Ciudad de México, UTC−6).
// A partir del 1 de noviembre a las 00:00 solo queda el boleto individual de $150.
const PROMO_END = Date.UTC(2026, 10, 1, 6, 0, 0);

export function promoActive() {
  return Date.now() < PROMO_END;
}
